<main class="main">
    <div class="container">
        <h5 class="text-center">No tasks assigned to you. Please contact administrator</h5>
    </div>
</main>